export default __webpack_public_path__ + "static/media/radar_color.766c1f7c.svg";